import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Heading, Text } from '@chakra-ui/react';
import FinancialStatements from '../../components/FinancialStatements';
import {
  DEFAULT_FINANCIAL_STATEMENT,
  getFinancialStatementBySlug,
  isKnownFinancialStatementSlug,
} from './financialStatementRoutes';

function StockHome() {
  const { ticker, statementSlug } = useParams();
  const navigate = useNavigate();
  const selectedStatement = getFinancialStatementBySlug(statementSlug);

  useEffect(() => {
    if (!ticker) {
      return;
    }

    if (!statementSlug || !isKnownFinancialStatementSlug(statementSlug)) {
      navigate(
        `/stock/${ticker.toLowerCase()}/financials/${DEFAULT_FINANCIAL_STATEMENT.slug}`,
        { replace: true }
      );
    }
  }, [navigate, statementSlug, ticker]);

  return (
    <Box p={4}>
      <Heading>Financial Statements</Heading>
      <Text fontSize="xl" mt={2}>
        You're viewing financial statements for: <strong>{ticker.toUpperCase()}</strong>
      </Text>
      <FinancialStatements
        ticker={ticker}
        selectedStatement={selectedStatement}
      />
    </Box>
  );
}

export default StockHome;
